export var wrapWithElement = function (html, elementTag, cssClass) {
    return "<".concat(elementTag, " class=\"").concat(cssClass, "\">").concat(html, "</").concat(elementTag, ">");
};
//# sourceMappingURL=wrap-with-element.js.map